import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';

import useListPage from 'hooks/useListPage';
const UsersListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const filterSchema = {
		user_role_id: {
			tagTitle: "User Role Id",
			value: '',
			valueType: 'single',
			options: [],
		},
		city: {
			tagTitle: "City",
			value: '',
			valueType: 'single',
			options: [],
		},
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/users/view/${data.userid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('users/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/users/edit/${data.userid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('users/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.userid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('users/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function UseridTemplate(data){
		if(data){
			return (
				<Link to={`/users/view/${data.userid}`}> { data.userid }</Link>
			);
		}
	}
	function EmailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.email}`}>{ data.email }</a>
			);
		}
	}
	function PhonenumberTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`tel:${data.phonenumber}`}>{ data.phonenumber }</a>
			);
		}
	}
	function IsemailverifiedTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.isemailverified}`}>{ data.isemailverified }</a>
			);
		}
	}
	function IsphoneverifiedTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`tel:${data.isphoneverified}`}>{ data.isphoneverified }</a>
			);
		}
	}
	function ProfilePhotoTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.profile_photo} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function ProfilephotourlTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.profilephotourl} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="users/delete">
		<MultiDelete />
	</CanView>
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="UsersListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Users"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/users/add`}>
                            <Button label="Add New User" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('user_role_id', options)}  apiPath="components_data/user_role_id_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'user_role_id', e.value)} value={filters.user_role_id.value} optionLabel="label" optionValue="value" options={filters.user_role_id.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('city', options)}  apiPath="components_data/city_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'city', e.value)} value={filters.city.value} optionLabel="label" optionValue="value" options={filters.city.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="userid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="userid" header="Userid" body={UseridTemplate} sortable={true} ></Column>
                                    <Column  field="username" header="Username"  sortable={true} ></Column>
                                    <Column  field="email" header="Email" body={EmailTemplate} sortable={true} ></Column>
                                    <Column  field="fullname" header="Fullname"  sortable={true} ></Column>
                                    <Column  field="phonenumber" header="Phonenumber" body={PhonenumberTemplate} sortable={true} ></Column>
                                    <Column  field="address" header="Address"  sortable={true} ></Column>
                                    <Column  field="city" header="City"  sortable={true} ></Column>
                                    <Column  field="state" header="State"  sortable={true} ></Column>
                                    <Column  field="zipcode" header="Zipcode"  sortable={true} ></Column>
                                    <Column  field="dateofbirth" header="Dateofbirth"   ></Column>
                                    <Column  field="registrationdate" header="Registrationdate"   ></Column>
                                    <Column  field="lastlogin" header="Lastlogin"   ></Column>
                                    <Column  field="isemailverified" header="Isemailverified" body={IsemailverifiedTemplate}  ></Column>
                                    <Column  field="isphoneverified" header="Isphoneverified" body={IsphoneverifiedTemplate}  ></Column>
                                    <Column  field="isactive" header="Isactive"   ></Column>
                                    <Column  field="isadmin" header="Isadmin"   ></Column>
                                    <Column  field="loyaltypoints" header="Loyaltypoints"   ></Column>
                                    <Column  field="preferredpaymentmethod" header="Preferredpaymentmethod"   ></Column>
                                    <Column  field="notes" header="Notes"   ></Column>
                                    <Column  field="user_role_id" header="User Role Id"   ></Column>
                                    <Column  field="profile_photo" header="Profile Photo" body={ProfilePhotoTemplate}  ></Column>
                                    <Column  field="date_created" header="Date Created"   ></Column>
                                    <Column  field="date_updated" header="Date Updated"   ></Column>
                                    <Column  field="authprovider" header="Authprovider"   ></Column>
                                    <Column  field="provideruserid" header="Provideruserid"   ></Column>
                                    <Column  field="profilephotourl" header="Profilephotourl" body={ProfilephotourlTemplate}  ></Column>
                                    <Column  field="account_number" header="Account Number"   ></Column>
                                    <Column  field="ifsc_code" header="Ifsc Code"   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
UsersListPage.defaultProps = {
	primaryKey: 'userid',
	pageName: 'users',
	apiPath: 'users/index',
	routeName: 'userslist',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default UsersListPage;
